module.exports = __webpack_public_path__ + "static/media/payments.bcf3321b.svg";